exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".response-container[data-v-3f745e67]{padding:20px;background:#fff;border-radius:8px;box-shadow:0 0 10px rgba(0,0,0,.1)}h1[data-v-3f745e67]{font-size:24px;margin-bottom:20px}ul[data-v-3f745e67]{list-style:none;padding:0}li[data-v-3f745e67]{margin-bottom:10px;font-size:18px}strong[data-v-3f745e67]{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f745e67","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/ulip/ICEGATE06_ResponseDisplay.vue
// module id = 1529
// module chunks = 0